export default __webpack_public_path__ + "static/media/life-ring_negative.2a746465.svg";